import React, { useState } from 'react';
import { useProperty } from '../../context/PropertyContext';
import './FilterPanel.css';

const PROPERTY_TYPES = ['Room', 'Flat', 'PG', '1BHK', '2BHK', '3BHK', 'Studio', 'Villa', 'Office'];
const AMENITIES_LIST = ['WiFi', 'AC', 'Parking', 'Gym', 'Pool', 'Laundry', 'Security', 'Power Backup', 'Lift', 'CCTV', 'Kitchen', 'Balcony', 'Garden'];
const FURNISHED_OPTIONS = ['Bare Shell', 'Semi-Furnished', 'Fully Furnished'];
const BEDROOM_OPTIONS = [0, 1, 2, 3, 4];

export default function FilterPanel({ onClose }) {
  const { filters, applyFilters, fetchProperties } = useProperty();
  const [local, setLocal] = useState({ furnished: '', minBedrooms: '', ...filters });

  const toggleAmenity = (a) => {
    setLocal(prev => ({
      ...prev,
      amenities: prev.amenities.includes(a)
        ? prev.amenities.filter(x => x !== a)
        : [...prev.amenities, a]
    }));
  };

  const handleApply = () => {
    applyFilters(local);
    onClose?.();
  };

  const handleReset = () => {
    const reset = { city: '', area: '', minPrice: '', maxPrice: '', propertyType: '', amenities: [], furnished: '', minBedrooms: '' };
    setLocal(reset);
    applyFilters(reset, { track: false });
    onClose?.();
  };

  return (
    <div className="filter-panel">
      <div className="filter-header">
        <h3>Filters</h3>
        <button className="filter-close" onClick={onClose}>✕</button>
      </div>

      <div className="filter-body">
        <div className="filter-section">
          <label className="filter-label">City</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g. Bangalore, Mumbai..."
            value={local.city}
            onChange={e => setLocal(p => ({ ...p, city: e.target.value }))}
          />
        </div>

        <div className="filter-section">
          <label className="filter-label">Area / Locality</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g. Koramangala, Bandra..."
            value={local.area}
            onChange={e => setLocal(p => ({ ...p, area: e.target.value }))}
          />
        </div>

        <div className="filter-section">
          <label className="filter-label">Price Range (₹/month)</label>
          <div className="price-range-row">
            <input
              type="number"
              className="form-input"
              placeholder="Min"
              value={local.minPrice}
              onChange={e => setLocal(p => ({ ...p, minPrice: e.target.value }))}
            />
            <span className="range-sep">–</span>
            <input
              type="number"
              className="form-input"
              placeholder="Max"
              value={local.maxPrice}
              onChange={e => setLocal(p => ({ ...p, maxPrice: e.target.value }))}
            />
          </div>
          <div className="price-presets">
            {[5000, 10000, 20000, 50000].map(v => (
              <button
                key={v}
                className={`preset-btn ${local.maxPrice == v ? 'active' : ''}`}
                onClick={() => setLocal(p => ({ ...p, maxPrice: v }))}
              >
                Under ₹{v.toLocaleString()}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <label className="filter-label">Property Type</label>
          <div className="type-grid">
            {PROPERTY_TYPES.map(t => (
              <button
                key={t}
                className={`type-btn ${local.propertyType === t ? 'active' : ''}`}
                onClick={() => setLocal(p => ({ ...p, propertyType: p.propertyType === t ? '' : t }))}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <label className="filter-label">Furnished Status</label>
          <div className="type-grid">
            {FURNISHED_OPTIONS.map(f => (
              <button key={f} className={`type-btn ${local.furnished === f ? 'active' : ''}`}
                onClick={() => setLocal(p => ({ ...p, furnished: p.furnished === f ? '' : f }))}>
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <label className="filter-label">Min. Bedrooms</label>
          <div className="bedroom-row">
            {BEDROOM_OPTIONS.map(n => (
              <button key={n} className={`bedroom-btn ${local.minBedrooms == n ? 'active' : ''}`}
                onClick={() => setLocal(p => ({ ...p, minBedrooms: p.minBedrooms == n ? '' : n }))}>
                {n === 0 ? 'Any' : n === 4 ? '4+' : n}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <label className="filter-label">Amenities</label>
          <div className="amenities-grid">
            {AMENITIES_LIST.map(a => (
              <label key={a} className={`amenity-chip ${local.amenities.includes(a) ? 'active' : ''}`}>
                <input
                  type="checkbox"
                  checked={local.amenities.includes(a)}
                  onChange={() => toggleAmenity(a)}
                />
                {a}
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="filter-footer">
        <button className="btn btn-secondary" onClick={handleReset}>Reset All</button>
        <button className="btn btn-primary" onClick={handleApply}>
          Apply Filters
          {(local.propertyType || local.amenities.length || local.minPrice || local.maxPrice || local.city || local.area || local.furnished || local.minBedrooms) &&
            <span className="filter-count">
              {[local.propertyType, local.city, local.area, local.furnished, local.minBedrooms, ...local.amenities, local.minPrice && 'minPrice', local.maxPrice && 'maxPrice'].filter(Boolean).length}
            </span>
          }
        </button>
      </div>
    </div>
  );
}
